import NumberInput from 'components/forms/inputs/rhf-inputs/NumberInput.tsx';
import InfoTooltip from 'components/InfoTooltip.tsx';
import { ModalFooter } from 'components/modals/ModalFooter';
import { ModalHeader } from 'components/modals/ModalHeader';
import { useForm } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { AutoblockCriteriaForm } from 'types/tenants';
import { t } from 'utils/getTranslations';

interface Props {
    initialData: AutoblockCriteriaForm;
    onSubmit: (data: AutoblockCriteriaForm) => void;
    onClose: () => void;
}

const AutoblockCriteriaEditModal = (props: Props) => {
    const { initialData, onSubmit, onClose } = props;

    const { handleSubmit, control } = useForm<AutoblockCriteriaForm>({
        defaultValues: initialData,
    });

    const onSave = () => handleSubmit((data) => onSubmit(data))();

    return (
        <>
            <ModalHeader title={t('configuration.debt-collection')} onCancel={onClose} />
            <div className="h-full overflow-y-auto px-[23px] pt-[15px] pb-[45px]">
                <div className="mt-6">
                    <h6 className="text-h6 mb-2">
                        <FormattedMessage id="configuration.autoblock-criteria" />
                    </h6>
                    <p className="text-body2">
                        <FormattedMessage id="configuration.autoblock-criteria-help-text" />
                    </p>
                    <NumberInput
                        name="matterBlockingDebtClientThresholdAmount"
                        control={control}
                        label="configuration.debt-threshold-amount"
                        inputProps={{ min: 0, step: 1 }}
                        wrapperClassName="mt-6 w-1/4"
                        rightLabelComponent={<InfoTooltip text="configuration.debt-threshold-amount-tooltip" />}
                    />
                    <NumberInput
                        required
                        name="matterBlockingGracePeriodDays"
                        control={control}
                        label="configuration.debt-grace-period-days"
                        inputProps={{ min: 0 }}
                        wrapperClassName="mt-6 w-1/4"
                        rightLabelComponent={<InfoTooltip text="configuration.debt-grace-period-days-tooltip" />}
                    />
                    <NumberInput
                        required
                        name="matterBlockingWarningPeriodDays"
                        control={control}
                        label="configuration.autoblock-warning-days"
                        inputProps={{ min: 0 }}
                        wrapperClassName="mt-6 w-1/4"
                        rightLabelComponent={<InfoTooltip text="configuration.autoblock-warning-days-tooltip" />}
                    />
                </div>
            </div>
            <ModalFooter
                onCancel={onClose}
                onSave={() => {
                    void onSave();
                }}
            />
        </>
    );
};

export default AutoblockCriteriaEditModal;
